import { errorFromResponse } from '~/app/notifications'
import { mutations, actions as parentActions, state } from '~/sites/shop/store/product'
import reduce from 'lodash/reduce'

const actions = {
  ...parentActions,
  async ADD_AVAILABILITY_WATCHER({ commit, dispatch }, { variantId, email }) {
    try {
      const url = `${this.$env.STORE_URL}/api/v1/products/${variantId}/watchers`
      const response = await this.$axios.$post(url, { email: email })
      return response.data
    } catch (e) {
      errorFromResponse(e.response)

      return {
        success: false,
        error: e.message || 'Network Error',
        isValid: false,
        data: null,
      }
    }
  },

  async LOAD_PRODUCTS(
    { commit, dispatch },
    { ids, codes, categoryIds, eans, variantCodes, variantEans, random, context = null, variantIds = [] },
  ) {
    try {
      const isIdFilter = ids && ids.length > 0
      const isCodeFilter = codes && codes.length > 0
      const isCategoryFilter = categoryIds && categoryIds.length > 0
      const isEanFilter = eans && eans.length > 0
      const isVariantCodeFilter = variantCodes && variantCodes.length > 0
      const isVariantEanFilter = variantEans && variantEans.length > 0
      if (
        !isIdFilter &&
        !isCodeFilter &&
        !isCategoryFilter &&
        !isEanFilter &&
        !isVariantCodeFilter &&
        !isVariantEanFilter &&
        !random
      ) {
        return []
      }

      const queryParts = []

      if (random && categoryIds) {
        queryParts.push(`categoryIds=${categoryIds.join(',')}`)
        queryParts.push(`random=${random}`)
      } else if (random) {
        queryParts.push(`random=${random}`)
      } else if (isIdFilter) {
        queryParts.push(`ids=${ids.join(',')}`)
      } else if (isCodeFilter) {
        queryParts.push(`codes=${codes.join(',')}`)
      } else if (isEanFilter) {
        queryParts.push(`eans=${eans.join(',')}`)
      } else if (isVariantCodeFilter) {
        queryParts.push(`variantCodes=${variantCodes.join(',')}`)
      } else if (categoryIds) {
        queryParts.push(`categoryIds=${categoryIds.join(',')}`)
      } else {
        queryParts.push(`variantEans=${variantEans.join(',')}`)
      }

      if (context) {
        queryParts.push(`context=${encodeURIComponent(context)}`)
      }

      if (variantIds && variantIds.length > 0) {
        queryParts.push(`variantIds=${variantIds.join(',')}`)
      }

      const response = await this.$axios.$get(`${this.$env.CMS_URL}/catalog/product?${queryParts.join('&')}`)
      return response
    } catch (e) {
      console.error(e)
    }
  },

  async LOAD_PRODUCT({ commit, dispatch }, { slug }) {
    try {
      const response = await this.$axios.$get(
        this.$env.CMS_URL + '/catalog/product?checkPermissions=true&slugs=' + slug,
      )
      if (response.error) {
        return { error: response.error }
      }
      return response[0]
    } catch (e) {
      console.error(e)
    }
  },

  async UPDATE_PRODUCT_ATTRIBUTES({ commit, dispatch }, { id, config }) {
    try {
      const { width, height, configuration, extras = {} } = config || {}
      const requestId = extras.externalId || extras.productId || id
      const data = {
        include: ['tags', 'variants', 'alternatives'],
        configuration: {
          width,
          height,
          ...reduce(
            configuration,
            (acc, item) => {
              return { ...acc, ...item }
            },
            {},
          ),
        },
        ...extras,
      }
      const response = await this.$axios.$post(`${this.$env.STORE_URL}/api/v1/products/${requestId}/configurator`, data)
      const priceWithTax = Number(response?.data?.prices?.unitWithTax)

      if (response?.data?.attributes?.configurationError || !Number.isFinite(priceWithTax) || priceWithTax <= 0) {
        return {
          success: false,
          error: 'Pro zvolenou konfiguraci se nepodařilo spočítat cenu.',
          isValid: false,
          data: null,
        }
      }

      return {
        success: true,
        data: response.data,
        isValid: true,
      }
    } catch (e) {
      const response = e.response
      if (response && response.data && response.data.errors && response.data.errors[0]) {
        return {
          success: false,
          error: response.data.errors[0].title,
          isValid: false,
          data: null,
        }
      } else {
        errorFromResponse(response)
        return {
          success: false,
          error: e.message || 'Network Error',
          isValid: false,
          data: null,
        }
      }
    }
  },
}

export { actions, mutations, state }
